import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { displayDateWithTime } from "../formatting/displayDateWithTime";
import { Explanation } from "../support/Explanation/Explanation";
import { DownloadDocumentIconButton } from "./DownloadDocumentIconButton/DownloadDocumentIconButton";

interface DocumentRow {
  id: string;
  name: string;
  uploadedAt: string;
}

interface Props {
  documents: DocumentRow[];
  // Document ids that must download via the sourcing-event-scoped (access-restricted) route rather than the
  // generic one — used for documents the buyer published to all tenderers. Requires eventId.
  restrictedDocumentIds?: Set<string>;
  eventId?: string;
}

export const DocumentsAsOwnerTable = ({ documents, restrictedDocumentIds, eventId }: Props) => {
  const { t } = useTranslation();
  return (
    <Box borderRadius={"md"} border="1px solid" borderColor="smBorder" pb="2.5">
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>{t("Name")}</Th>
            <Th>{t("Upload date")}</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {documents.map((e) => {
            return (
              <Tr key={e.id}>
                <Td>{e.name}</Td>
                <Td>{displayDateWithTime(e.uploadedAt, t("at"))}</Td>
                <Td>
                  <Flex justifyContent="end">
                    <Explanation text={t("Download document")} shouldWrapChildren>
                      <DownloadDocumentIconButton
                        documentId={e.id}
                        eventId={restrictedDocumentIds?.has(e.id) ? eventId : undefined}
                      />
                    </Explanation>
                  </Flex>
                </Td>
              </Tr>
            );
          })}
          {documents.length === 0 && (
            <Tr>
              <Td colSpan={3} width={"100%"} textAlign="center" fontSize={"small"}>
                {t("No documents have been uploaded")}
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Box>
  );
};
